import React, { useState } from 'react';
import RequestRepair from '../components/RequestRepair/RequestRepair';
import OrderReceived from '../components/OrderReceived/OrderReceived';
import FloatingButton from '../components/FloatingButton/FloatingButton';

export default function DisclaimerPage() {
  const [showRepair, setShowRepair] = useState(false);
  const [showOrderReceived, setShowOrderReceived] = useState(false);
  const [orderId, setOrderId] = useState(null);

  const handleRepairSubmit = (submittedOrderId) => {
    setOrderId(submittedOrderId);
    setShowRepair(false);
    setShowOrderReceived(true);
  };

  return (
    <>
      <div className="policy-page-wrapper">
        {/* Background Ambient Elements */}
        <div className="policy-bg-glow" aria-hidden="true" />
        <div className="policy-bg-dots-left" aria-hidden="true" />
        <div className="policy-bg-dots-right" aria-hidden="true" />

        <div className="policy-container">
          <header className="policy-header">
            <div className="policy-badge">
              <span className="star-icon">★</span>
              <span>IMPORTANT NOTICE</span>
            </div>

            <h1>
              Service <span className="gold-text">Disclaimer</span>
            </h1>

            {/* Gold Diamond Divider */}
            <div className="heading-divider" aria-hidden="true">
              <div className="divider-line" />
              <div className="divider-diamond" />
              <div className="divider-line" />
            </div>

            <p className="subnote">Independent Repair Service • Not affiliated with any brand</p>
            <p className="effective-date">Effective Date: 07/08/2026</p>
          </header>

          <div className="policy-content">
            <p className="intro">
              The information and services provided by DoorStep Maintenance &amp; Repair (DSMR) are offered in good faith and with the intention of delivering reliable doorstep repair solutions. However, by accessing our website and using our repair services, you acknowledge and agree to the following disclaimers, operational policies, and limitations of liability.
            </p>

            <section className="policy-section">
              <h2>0. Independence &amp; Non‑Affiliation</h2>
              <ul>
                <li>DSMR Solutions is an independent, third-party multi-brand repair service provider.</li>
                <li>We are not affiliated, associated, authorized, endorsed by, or in any way officially connected with any original equipment manufacturer (OEM) or brand, including but not limited to Apple, iPhone, Samsung, Xiaomi, Huawei, OnePlus, Google, Vivo, Oppo, RealMe, HP, Dell, Lenovo, ASUS, Acer, or any of their subsidiaries or affiliates.</li>
                <li>All trademarks, brand names, product titles, logos, and registered service marks mentioned on this website are the property of their respective owners and are used strictly for identification and informational purposes.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>1. General Information &amp; Website Disclaimer</h2>
              <ul>
                <li>All content on our website—including repair cost estimates, service descriptions, blogs, guides, and FAQs—is provided for general informational purposes only.</li>
                <li>While we strive to maintain accurate and up-to-date information, we make no express or implied warranties or guarantees regarding the completeness, reliability, accuracy, or suitability of any content displayed.</li>
                <li>Prices and repair turnarounds shown on the site are estimates and subject to final diagnosis by our technicians at the time of service.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>2. Service &amp; Technical Diagnostics Disclaimer</h2>
              <ul>
                <li><strong>Pre-existing Conditions:</strong> Repair outcomes depend on the physical condition of the device, prior repairs by third parties, and pre-existing hardware or liquid damage. We cannot guarantee 100% repair success in all cases.</li>
                <li><strong>Diagnostic &amp; Opening Risks:</strong> In cases of severe drop damage, liquid exposure, or degraded motherboards, opening the device for inspection may reveal further latent hardware failures. DSMR is not liable for secondary failures caused by pre-existing structural weakness.</li>
                <li><strong>Data Loss:</strong> Hardware repair or diagnostic operations carry inherent risks to stored data. Data recovery attempts are not guaranteed. Customers are strictly required to back up all personal data prior to handed-over service.</li>
                <li><strong>Replacement Parts:</strong> Depending on customer selection and availability, replacement parts used may be OEM-grade, high-quality compatible, or refurbished components. All parts used are backed by our explicit Warranty Policy.</li>
                <li><strong>Manufacturer Warranties:</strong> Servicing your device with an independent repair provider may void any existing original manufacturer warranty or insurance coverage. Customers accept this risk upon booking.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>3. Safety, Security, Data Handling &amp; Technician Welfare</h2>
              <ul>
                <li>We adhere to professional device handling standards, including anti-static ESD safety protocols and secure protective handling during transit.</li>
                <li>Our technicians will never access personal files, photos, or apps unless explicitly authorized by the customer for functional testing (e.g., camera, microphone, or sensor check).</li>
                <li>Personal customer information collected during booking is strictly handled per our Privacy Policy for appointment scheduling, invoicing, and warranty support.</li>
                <li><strong>Technician Safety &amp; Respectful Environment:</strong> Doorstep visits require a safe, non-threatening, and clean working space. DSMR technicians reserve the right to decline or suspend service if they experience unsafe conditions, harassment, or hostility.</li>
                <li>For customer safety, doorstep visits are performed by verified technicians carrying DSMR credentials. Customers may verify technician identity prior to allowing entry.</li>
                <li><strong>Payment Safety:</strong> Digital payments are processed through secure payment gateways. DSMR staff will never ask for confidential banking PINs, card CVVs, or bank OTPs.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Limitation of Liability</h2>
              <ul>
                <li>To the maximum extent permitted by applicable law, DSMR Solutions, its technicians, employees, and partners shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from the use of our repair services or website.</li>
                <li>Our cumulative monetary liability for any claim arising from a repair service shall in no event exceed the total service amount actually paid by the customer for that specific repair order.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>5. External Links &amp; Third-Party Services</h2>
              <ul>
                <li>Our website may contain links to third-party payment gateways, maps, or external resources. We do not control or assume responsibility for the content, privacy practices, or security of any third-party websites or services.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>6. Contact Us</h2>
              <p>If you have any questions or require clarification regarding this Service Disclaimer, please contact us:</p>
              <div className="contact-info">
                <p><strong>DSMR Solutions</strong></p>
                <p>Website: dsmrsolutions.in</p>
                <p>Phone: +91.8700319769</p>
                <p>Email: support@dsmrsolutions.in</p>
              </div>
            </section>
          </div>
        </div>

        {showRepair && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.4)',
            zIndex: 3000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <RequestRepair
              isModal={true}
              onClose={() => setShowRepair(false)}
              onSubmit={handleRepairSubmit}
            />
          </div>
        )}

        {showOrderReceived && (
          <OrderReceived
            orderId={orderId}
            onClose={() => setShowOrderReceived(false)}
          />
        )}



        <style>{`
          .policy-page-wrapper {
            min-height: 100vh;
            background: linear-gradient(135deg, #f9f4ee 0%, #fbf6f1 35%, #fdf8f5 70%, #fdf9f4 100%);
            padding: 8rem 1.5rem 4rem 1.5rem;
            position: relative;
            overflow: hidden;
            font-family: 'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          }

          .policy-bg-glow {
            position: absolute;
            top: -20px;
            left: 50%;
            transform: translateX(-50%);
            width: 900px;
            height: 480px;
            background: radial-gradient(ellipse at center, rgba(235, 205, 155, 0.35) 0%, rgba(250, 246, 240, 0) 70%);
            pointer-events: none;
            z-index: 0;
          }

          .policy-bg-dots-left {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 300px;
            background-image: radial-gradient(#C99E54 1.4px, transparent 1.4px);
            background-size: 22px 22px;
            opacity: 0.25;
            mask-image: linear-gradient(to right, rgba(0,0,0,0.8), transparent);
            -webkit-mask-image: linear-gradient(to right, rgba(0,0,0,0.8), transparent);
            pointer-events: none;
          }

          .policy-bg-dots-right {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            width: 300px;
            background-image: radial-gradient(#C99E54 1.4px, transparent 1.4px);
            background-size: 22px 22px;
            opacity: 0.25;
            mask-image: linear-gradient(to left, rgba(0,0,0,0.8), transparent);
            -webkit-mask-image: linear-gradient(to left, rgba(0,0,0,0.8), transparent);
            pointer-events: none;
          }

          .policy-container {
            max-width: 860px;
            margin: 0 auto;
            background: linear-gradient(135deg, #fefaf4 0%, #fdf9f3 35%, #fefaf6 70%, #fdf9f6 100%);
            border-radius: 24px;
            border: 1px solid rgba(201, 158, 84, 0.25);
            box-shadow: inset 0 1px 2px rgba(255,255,255,.95), 0 0 0 1px rgba(255,233,194,.45), 0 10px 24px rgba(191,160,110,.10), 0 14px 35px rgba(180,150,100,.09), 0 50px 100px rgba(180,150,100,.06);
            overflow: hidden;
            position: relative;
            z-index: 1;
          }

          .policy-header {
            background: linear-gradient(180deg, #FFFFFF 0%, #FAF5EE 100%);
            color: #0F172A;
            padding: 3rem 2.5rem 2rem 2.5rem;
            text-align: center;
            border-bottom: 1px solid rgba(201, 158, 84, 0.2);
          }

          .policy-badge {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 0.75rem;
            font-weight: 700;
            letter-spacing: 1.5px;
            color: #C99E54;
            background: rgba(201, 158, 84, 0.08);
            border: 1px solid rgba(201, 158, 84, 0.3);
            border-radius: 30px;
            padding: 6px 16px;
            margin-bottom: 1rem;
            text-transform: uppercase;
          }

          .star-icon {
            font-size: 0.85rem;
            color: #F0B040;
          }

          .policy-header h1 {
            font-size: 2.75rem;
            font-weight: 800;
            color: #0F172A;
            margin: 0 0 0.5rem 0;
            letter-spacing: -0.5px;
          }

          .gold-text {
            color: #C98E32;
            background: linear-gradient(135deg, #D99215 0%, #B88228 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .heading-divider {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            margin: 1rem 0 1.25rem 0;
          }

          .divider-line {
            height: 1px;
            width: 60px;
            background: linear-gradient(90deg, transparent, #C99E54, transparent);
          }

          .divider-diamond {
            width: 7px;
            height: 7px;
            background: #C99E54;
            transform: rotate(45deg);
          }

          .subnote {
            margin: 0 0 0.4rem 0;
            color: #64748B;
            font-size: 0.98rem;
            font-weight: 500;
          }

          .effective-date {
            font-size: 0.95rem;
            color: #94A3B8;
            margin: 0;
            font-weight: 500;
          }

          .policy-content {
            padding: 3rem 2.5rem;
            line-height: 1.8;
            color: #334155;
          }

          .intro {
            font-size: 1.08rem;
            margin-bottom: 1.5rem;
            padding: 1.5rem;
            background: rgba(201, 158, 84, 0.06);
            border-left: 4px solid #C99E54;
            border-radius: 0 12px 12px 0;
            color: #1E293B;
          }

          .policy-section {
            margin-bottom: 2.75rem;
          }

          .policy-section h2 {
            color: #0F172A;
            font-size: 1.45rem;
            font-weight: 700;
            margin-bottom: 1rem;
            padding-bottom: 0.5rem;
            border-bottom: 2px solid rgba(201, 158, 84, 0.18);
            display: flex;
            align-items: center;
          }

          .policy-section p {
            margin-bottom: 1rem;
            font-size: 1.02rem;
            color: #334155;
          }

          .policy-section ul,
          .policy-section ol {
            margin: 1rem 0 1.25rem 0;
            padding-left: 1.6rem;
          }

          .policy-section li {
            margin-bottom: 0.6rem;
            font-size: 1.02rem;
            color: #334155;
          }

          .contact-info {
            background: linear-gradient(135deg, #FFFDF9 0%, #FDF8F0 100%);
            padding: 1.75rem;
            border-radius: 14px;
            border: 1px solid rgba(201, 158, 84, 0.25);
            box-shadow: 0 4px 15px rgba(201, 158, 84, 0.06);
            margin-top: 1.25rem;
          }

          .contact-info p {
            margin: 0.5rem 0;
            font-size: 1.02rem;
          }

          .contact-info strong {
            color: #0F172A;
          }

          @media (max-width: 768px) {
            .policy-page-wrapper {
              padding: 6.5rem 1rem 2rem 1rem;
            }

            .policy-container {
              border-radius: 16px;
            }

            .policy-header {
              padding: 2.25rem 1.5rem 1.5rem 1.5rem;
            }

            .policy-header h1 {
              font-size: 2.1rem;
            }

            .policy-content {
              padding: 2rem 1.5rem;
            }

            .intro {
              font-size: 1rem;
              padding: 1.15rem;
            }

            .policy-section h2 {
              font-size: 1.3rem;
            }

            .policy-section p,
            .policy-section li {
              font-size: 0.98rem;
            }
          }

          @media (max-width: 480px) {
            .policy-page-wrapper {
              padding: 5.5rem 0.5rem 1.5rem 0.5rem;
            }

            .policy-header {
              padding: 1.75rem 1rem 1.25rem 1rem;
            }

            .policy-header h1 {
              font-size: 1.85rem;
            }

            .policy-content {
              padding: 1.5rem 1rem;
            }
          }
        `}</style>
      </div>
    </>
  );
}
